import { render, staticRenderFns } from "./DamageAssessorCaseLawyerCard.vue?vue&type=template&id=b375d090"
import script from "./DamageAssessorCaseLawyerCard.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseLawyerCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports